module.exports = __webpack_public_path__ + "aba0bb38b02dd36e5562a4d5a78a5029.png";